
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '@app/services/user.service';

@Component({
    selector: 'app-partner-sso-redirect',
    template: `
    <div class="loading-container">
      <div class="spinner"></div>
      <p>{{ loadingMessage }}</p>
    </div>
  `,
    styles: [`
    .loading-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
    }
    .spinner {
      width: 50px;
      height: 50px;
      border: 4px solid #f3f3f3;
      border-top: 4px solid #3498db;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `],
    standalone: false
})
export class PartnerSsoRedirectComponent implements OnInit {
  loadingMessage = 'Authenticating with PineLabs...';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService
  ) { }

  ngOnInit(): void {

    const enkashToken = this.route.snapshot.paramMap.get('token');


    const sourceUrl = this.route.snapshot.queryParamMap.get('sourceUrl');
    const pinelabsJwtToken = this.route.snapshot.queryParamMap.get('jwtToken');



    if (!enkashToken) {
      this.router.navigate(['/login'], {
        queryParams: { error: 'Invalid authentication token' }
      });
      return;
    }

    this.performSsoLogin(enkashToken, sourceUrl, pinelabsJwtToken);
  }

  private performSsoLogin(
    enkashToken: string,
    sourceUrl: string | null,
    pinelabsJwtToken: string | null
  ): void {
    this.loadingMessage = 'Authenticating with EnKash...';


    this.userService.loginPinelabsSso(enkashToken).subscribe(
      (currentUser) => {

        this.navigateToEnKashDashboard(currentUser);

      },
      (error) => {
        this.handleLoginError(error);
      }
    );
  }

  private navigateToEnKashDashboard(currentUser: any): void {
    this.loadingMessage = 'Completing authentication...';

    this.router.navigate(['/expense-management'], { queryParams: { activeTab: 'expense' } });
  }

  private handleLoginError(error: any): void {
    this.router.navigate(['/login'], {
      queryParams: {
        error: error?.error?.error_description || 'Authentication failed. Please try again.'
      }
    });
  }
}